import Alpine from "alpinejs";
import {$http} from "../../utils";

Alpine.data('search', () => ({
    searchInput: '',
    result: [],
    justOpen: true,

    handleSearch() {
        this.justOpen = false;

        if (this.searchInput.length < 3) {
            this.result = [];
            return;
        }

        $http.get(`/api/v1/search?search=${this.searchInput}`).then((response) => {
            console.log(response.data.data);
            this.result = response.data.data;
        })
    },

    reset() {
        this.result = [];
        this.searchInput = '';
    }
}))